import { useEffect, useState } from 'react';

import { Modal, Typography, openModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import {
  type OnBoardingResultReport,
  type OnboardingAnswer,
  type OnboardingResult,
} from '../core/type';

import { COLOR } from 'constants/color';

import { getOnBoardingResult } from '../core/services';
import { ResultChart } from './on-boarding/Chart';
import { CollapseBodyContent } from './on-boarding/CollapseBodyContent';
import { CollapseBodyHeader } from './on-boarding/CollapseBodyHeader';
import { CollapseHeader } from './on-boarding/CollapseHeader';
import { CollapseWrapper } from './on-boarding/CollapseWrapper';
import { TableHeader } from './on-boarding/TableHeader';

interface Props {
  visible: boolean;
  learnerId: string;
  showDetail: boolean;
}

export const OnboardingResultDrawer = ({ visible, learnerId, showDetail }: Props) => {
  const [onboardingResult, setOnboardingResult] = useState<OnBoardingResultReport | null>(null);
  const results = onboardingResult?.results || [];
  const [detail, setDetail] = useState<OnboardingResult | null>(null);
  const [note, setNote] = useState('');

  useEffect(() => {
    if (visible) {
      getOnBoardingResult(learnerId, (rs) => {
        setOnboardingResult(rs);

        if (rs?.results?.length && showDetail) {
          setDetail(rs.results[0]);
        }
      });
    } else {
      setDetail(null);
    }
  }, [visible]);

  const handleViewNote = (e: OnboardingAnswer) => {
    openModal(MODAL_KEY.VIEW_NOTE);
    setNote(e.comment!);
  };

  return (
    <div
      style={{
        transition: 'all 0.5s',
        width: 1120,
        maxWidth: '90vw',
        padding: 32,
        maxHeight: '100vh',
        overflow: 'auto',
      }}
    >
      <Typography variant="h3" color={COLOR.surfaceNeutralBold['neutral-11']} weight={500}>
        Baseline fitness test history
      </Typography>
      <div className="border-container p-16" style={{ marginBottom: 40, marginTop: 40 }}>
        <ResultChart results={results} />
      </div>
      <div className="border-container p-16">
        <TableHeader />
        {results.map((el, index) => {
          return (
            <CollapseWrapper
              defaultShow={index === 0 && detail ? true : false}
              visible={visible}
              key={el.id}
              renderHeader={(show) => <CollapseHeader show={show} result={el} />}
              body={
                <div style={{ backgroundColor: '#F7F4ED' }}>
                  <CollapseBodyHeader />
                  {el.answers.map((e, idx) => {
                    return (
                      <CollapseBodyContent
                        key={idx}
                        idx={idx}
                        answer={e}
                        handleViewNote={() => handleViewNote(e)}
                      />
                    );
                  })}
                </div>
              }
            />
          );
        })}
      </div>
      {note && (
        <Modal
          header={
            <Typography variant="h4" style={{ fontSize: 22, fontWeight: '500' }}>
              Note
            </Typography>
          }
          closeIconStyle={{
            width: 24,
            height: 24,
          }}
          modalKey={MODAL_KEY.VIEW_NOTE}
          submitButton={{ hide: true }}
          cancelButton={{ hide: true }}
          footer={<div style={{ height: 24 }}></div>}
        >
          <Typography
            variant="body-2"
            style={{ fontSize: 18, fontWeight: 400, lineHeight: '26px' }}
          >
            {note}
          </Typography>
        </Modal>
      )}
    </div>
  );
};
